import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import CommentForm from './comment-form';
import Comment from './comment';
import { Notice } from './styles';
import { propTypes } from './prop-types';

const Header = styled.h2`
  &&&& {
    font: ${props => dt(props).theme.fontWeightHeavy} 19px/22.8px ${props => dt(props).theme.fontFamilyBody};
    margin: 40px 0 20px 0;
    text-transform: uppercase;
  }
`;

export default function DesktopVariant({
  isCurrentUserConfirmed, wireSlug, showCommentLikeHint, comments,
}) {
  const isUserSignedIn = !!_.get(window, 'Livewire.currentUser.id');
  const notice = isUserSignedIn
    ? ('Your account currently has restricted access. '
      + 'Please check your email and click the email confirmation link to be '
      + 'able to post comments.')
    : 'Please sign in to comment on this wire.';

  return (
    <>
      <Header>Comments</Header>
      {
        (isUserSignedIn && isCurrentUserConfirmed)
          ? <CommentForm wireSlug={wireSlug} />
          : <Notice>{notice}</Notice>
      }
      {comments.map((c, i) => (
        <Comment
          {...c}
          key={c.id}
          isFirstComment={i === 0}
          showCommentLikeHint={showCommentLikeHint}
        />
      ))}
    </>
  );
}

DesktopVariant.propTypes = {
  wireSlug: PropTypes.string.isRequired,
  isCurrentUserConfirmed: PropTypes.bool.isRequired,
  showCommentLikeHint: PropTypes.bool.isRequired,
  comments: PropTypes.arrayOf(PropTypes.shape(propTypes)).isRequired,
};
